<template>
    <div class="row recent-orders">
        <!-- <div
            class="row mb-5"
            v-if="
                (this.user.role.id == 2 || this.user.role.id == 3) &&
                pageType != 'dashboard'
            "
        > -->
        <div
            class="row mb-5"
            v-if="
                (user.role_modules.includes('Synced Orders')) &&
                pageType != 'dashboard'
            "
        >
            <div class="col-12">
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'all';
                        getResults();
                    "
                    :class="filterType == 'all' ? 'active' : ''"
                >
                    ALL SYNCED ORDERS
                </button>
                <!-- <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'done';
                        getAllOrders(currentLocation, 'done');
                    "
                    :class="filterType == 'done' ? 'active' : ''"
                >
                    SHIPPED
                </button>
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'sale';
                        getAllOrders(currentLocation, 'sale');
                    "
                    :class="filterType == 'sale' ? 'active' : ''"
                >
                    OPEN
                </button>
                <button
                    class="btn filter-btn"
                    @click="
                        filterType = 'pending';
                        getAllOrders(currentLocation, 'Pending');
                    "
                    :class="filterType == 'pending' ? 'active' : ''"
                >
                    PENDING
                </button> -->
            </div>
        </div>
        <!-- SYNCED ORDERS -->
        <!-- <div
            v-if="user.role.id == 1 || user.role.id == 4 || user.role.id == 5"
            class="col-md-12"
        > -->
        <div
            v-if="user.role_modules.includes('Synced Orders')"
            class="col-md-12"
        >
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <h3>Synced Orders</h3>
                </div>
                <!-- <div
                    v-if="pageType != 'dashboard'"
                    class="col-sm-12 col-md-3 pb-2"
                >
                    <div class="row align-items-center">
                        <div class="col-md-3">
                            <label
                                class="form-control-label text-muted"
                                for="filter_status"
                                >Filter Status:
                            </label>
                        </div>
                        <div class="col-md-9">
                            <select
                                id="filter_status"
                                class="form-control"
                                v-model="searchStatus"
                                @change="selectStatus"
                            >
                                <option value="all">ALL</option>
                                <option value="Open">Open</option>
                                <option value="Shipped">Shipped</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    v-if="pageType != 'dashboard'"
                    class="col-sm-12 col-md-3 text-right"
                >
                    <div class="form-group">
                        <div class="input-group search-field">
                            <input
                                class="form-control"
                                type="text"
                                placeholder="Search Orders"
                                v-model="searchTerm"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th style="width: 8em">Order Number</th>
                        <th>RDD</th>
                        <th style="width: 10em">Order Date</th>
                        <th>PO Number</th>
                        <th>Pricelist</th>
                        <th>Dealer</th>
                        <th>Sales Rep</th>
                        <th class="text-right" style="width: 8em">Total</th>
                        <th style="width: 8em">Status</th>
                        <th style="width: 10em"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="order in syncedOrders.data" :key="order.id">
                        <td class="hyperlink" @click="viewOrder(order)">
                            <b v-if="user.is_demo">ORD-12345</b>
                            <b v-else>{{ order.id == 0 ? "" : order.id }}</b>
                        </td>
                        <td>{{ order.requested_delivery_date }}</td>
                        <td>{{ order.order_date }}</td>
                        <td>
                            <b>{{ order.po_number }}</b>
                        </td>
                        <td>
                            <template v-if="order.pricelist != null">
                                {{ order.pricelist.pricelist_name }}
                            </template>
                        </td>
                        <td>{{ order.location.name }}</td>
                        <td>{{ order.location.sales_rep?.name }}</td>
                        <td class="text-right">
                            ${{ $filters.moneyFormat(order.total) }}
                        </td>
                        <td>
                            <div
                                class="order-status"
                                :class="order.order_status.toLowerCase()"
                            >
                                {{ order.order_status }}
                            </div>
                        </td>
                        <td style="width: 20px" class="text-right">
                            <span
                                class="px-1 view-action"
                                @click="viewOrder(order)"
                                ><i class="fa fa-eye" aria-hidden="true"></i>
                                VIEW<br
                            /></span>
                            <span
                                v-if="
                                    !order.is_sync &&
                                    order.order_status.toLowerCase() ==
                                        'pending approval'
                                "
                                class="px-1 view-action"
                                @click="editOrder(order)"
                                ><i class="fa fa-pencil" aria-hidden="true"></i>
                                EDIT<br
                            /></span>
                            <span
                                v-if="order.order_status == 'Pending Approval'"
                                class="px-1 view-action"
                                @click="confirmModal(order)"
                                ><i class="fa fa-trash" aria-hidden="true"></i>
                                DELETE</span
                            >
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Pagination -->
            <!-- <table-pagination
                v-model="syncedOrders"
                :all-rows="searchAllOrdersbyTermSynced"
                :perPage="perPage2"
                @updateRow="updateRow2"
            >
            </table-pagination> -->

            <Bootstrap4Pagination
                :data="syncedOrders"
                @pagination-change-page="getResults"
                :align="'right'"
                :limit="1"
                :keepLength="true"
            >
                <template #prev-nav>
                    <i class="fa fa-arrow-left"></i> PREVIOUS</template
                >
                <template #next-nav>
                    NEXT <i class="fa fa-arrow-right"></i>
                </template>
            </Bootstrap4Pagination>
        </div>

        <!-- Confirmation modal -->
        <b-modal v-model="modalShowConfirm" hide-footer>
            <Confirmation
                v-if="modalShowConfirm"
                :title="'Are you sure you want to delete this order?'"
                @custom-func="deleteOrderById"
                @close-modal="closeModalConfirm"
            />
        </b-modal>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import TablePagination from "@/components/TablePagination.vue";
import { Bootstrap4Pagination } from "laravel-vue-pagination";

import Confirmation from "@/components/Confirmation.vue";

export default {
    props: ["pageType", "pageType2", "setStatus", "headerTitle"],
    emits: [],
    components: {
        TablePagination,
        Confirmation,
        Bootstrap4Pagination
    },
    setup() {
        const store = useStore();
        const route = useRoute();

        let user = computed(function () {
            return store.state.user;
        });
        let allOrders = computed(function () {
            return store.state.allOrders;
        });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let syncedOrders = computed(function () {
            return store.state.syncedOrders;
        });

        let settings = computed(function () {
            return store.state.settings;
        });

        function getAllOrders(currentLocation, filterType = null, page = 1) {
            store.dispatch("getAllOrders", {
                location_id: currentLocation.id,
                filterType: filterType,
                page: page
            });
        }

        function setOrderInfo(order) {
            store.commit("setOrderInfo", order);
        }

        function searchOrders(val) {
            store.dispatch("searchOrders", val);
        }

        function getAllSyncedOrders(page = 1) {
            store.dispatch("getAllSyncedOrders", { page: page});
        }

        onMounted(() => {});

        return {
            store,
            route,
            user,
            allOrders,
            currentLocation,
            syncedOrders,
            settings,
            getAllOrders,
            setOrderInfo,
            searchOrders,
            getAllSyncedOrders,
        };
    },
    data() {
        return {
            paginatedOrders: [],
            perPage: this.pageType == "dashboard" && this.pageType2 ? 5 : 50,
            searchTerm: "",
            searchStatus: "all",
            modalShowConfirm: false,
            reqOrder: {
                id: null,
                location_id: null,
            },
            paginatedSyncedOrders: [],
            perPage2: 50,
            filterType: "all",
        };
    },
    computed: {
        searchAllOrdersbyTermSynced() {
            if (this.searchTerm === "" && this.searchStatus === "all") {
                return this.syncedOrders;
            }

            var filterArr = [];
            var filterArr2 = [];
            var result = [];

            if (this.searchStatus !== "all") {
                this.syncedOrders.forEach((order) => {
                    if (this.searchStatus == "Open") {
                        if (
                            order.order_status == "Open" ||
                            order.order_status == "Pending Approval" ||
                            order.order_status == "Confirmed" ||
                            order.order_status == "Partially Shipped"
                        ) {
                            filterArr.push(order);
                        }
                    }
                    if (this.searchStatus == "Shipped") {
                        if (order.order_status == "Shipped") {
                            filterArr.push(order);
                        }
                    }
                });
            }

            if (this.searchTerm !== "") {
                this.syncedOrders.forEach((order) => {
                    let pricelist_name = order.pricelist
                        ? order.pricelist.pricelist_name
                        : "";
                    let searchTermLower = this.searchTerm.toLowerCase();

                    if (
                        (order.po_number &&
                            order.po_number
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.order_number &&
                            order.order_number
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.payment_terms &&
                            order.payment_terms
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.notes &&
                            order.notes
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.location &&
                            order.location.name &&
                            order.location.name
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (String(order.id) &&
                            String(order.id)
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (pricelist_name &&
                            pricelist_name
                                .toLowerCase()
                                .includes(searchTermLower)) ||
                        (order.location &&
                            order.location.sales_rep &&
                            order.location.sales_rep.name &&
                            order.location.sales_rep.name
                                .toLowerCase()
                                .includes(searchTermLower))
                    ) {
                        filterArr2.push(order);
                    }
                });
            }

            if (this.searchStatus !== "all" && this.searchTerm !== "") {
                result = filterArr.filter(
                    (c) => filterArr2.findIndex((x) => x.id == c.id) > -1
                );
            } else if (this.searchStatus !== "all" && this.searchTerm === "") {
                result = filterArr;
            } else if (this.searchStatus === "all" && this.searchTerm !== "") {
                result = filterArr2;
            }

            return result;
        },

        autoConfirm() {
            return this.$store.state.settings.auto_confirm_orders;
        },
    },
    watch: {
        
    },
    mounted() {
        // if (
        //     this.user.role.id == 1 ||
        //     this.user.role.id == 4 ||
        //     this.user.role.id == 5
        // ) {
        if (this.user.role_modules.includes('Synced Orders')) {
            this.getAllSyncedOrders();
        }
    },
    methods: {
        getResults(page = 1) {
          this.getAllSyncedOrders(page)
        },
        toggleAutoConfirm() {
            axios.get("api/settings/toggle/auto-confirm").then((res) => {
                this.$store.dispatch("getSettings");
            });
        },
        updateRow(val) {
            this.paginatedOrders = val;
        },
        updateRow2(val) {
            this.paginatedSyncedOrders = val;
        },
        viewOrder(order) {
            // this.setOrderInfo(order);
            this.$router.push({
                name: "orderInfo",
                params: { id: order.id, order_number: order.order_number },
            });
        },
        editOrder(order) {
            // this.setOrderInfo(order);
            this.$router.push({
                name: "orderEdit",
                params: { id: order.id, order_number: order.order_number },
            });
        },
        confirmModal(order) {
            this.reqOrder = {
                id: order.id,
                location_id: this.currentLocation.id,
            };
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        deleteOrderById() {
            this.store.dispatch("deleteOrder", this.reqOrder).then((resp) => {
                window.emitter.emit("alertSuccess", {
                    message: "Order deleted successfully!",
                });
            });
        },
        closeModalConfirm() {
            this.modalShowConfirm = !this.modalShowConfirm;
        },
        onChange() {
            this.searchOrders({
                searchTerm: this.searchTerm,
            });
        },
    },
};
</script>
<style scoped>
.filter-btn {
    font-weight: 600;
    background-color: #e1e1e1;
    margin-right: 5px;
    font-weight: 700;
    font-family: "TT-Norms-ExtraBold";
}

.filter-btn.active {
    font-weight: 600;
    background-color: #d8312a;
    margin-right: 5px;
    color: white;
}
</style>
